import { render, staticRenderFns } from "./RateVersionHistory.vue?vue&type=template&id=55c1b7a8&scoped=true"
import script from "./RateVersionHistory.vue?vue&type=script&lang=js"
export * from "./RateVersionHistory.vue?vue&type=script&lang=js"
import style0 from "./RateVersionHistory.vue?vue&type=style&index=0&id=55c1b7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1b7a8",
  null
  
)

export default component.exports